module.exports = __webpack_public_path__ + "img/cirR.dd6e9e85.png";